import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticatedGuard } from './guards/authenticated.guard';

const routes: Routes = [
  { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
  { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthenticatedGuard] },
  { path: 'contracts', loadChildren: () => import('./clients/clients.module').then(m => m.ClientsModule), canActivate: [AuthenticatedGuard] },
  { path: 'plantillas', loadChildren: () => import('./plantillas/plantillas.module').then(m => m.PlantillasModule), canActivate: [AuthenticatedGuard] },
  { path: 'gestores', loadChildren: () => import('./gestores/gestores.module').then(m => m.GestoresModule), canActivate: [AuthenticatedGuard] },
  { path: 'pagos-sin-procesar', loadChildren: () => import('./pagos-sin-procesar/pagos-sin-procesar.module').then(m => m.PagosSinProcesarModule), canActivate: [AuthenticatedGuard] },

  // Redirección del catálogo y cobranza al dashboard
  { path: 'catalogo', redirectTo: 'dashboard/catalogo', pathMatch: 'prefix' },
  { path: 'cobranza', redirectTo: 'dashboard/cobranza', pathMatch: 'prefix' },
  
  // Redirecciones para mantener compatibilidad con URLs antiguas de usuarios
  { path: 'usuarios/index', redirectTo: 'dashboard/usuarios/index', pathMatch: 'full' },
  { path: 'usuarios/aprobados', redirectTo: 'dashboard/usuarios/aprobados', pathMatch: 'full' },
  { path: 'usuarios/notificaciones', redirectTo: 'dashboard/usuarios/notificaciones', pathMatch: 'full' },
  { path: 'usuarios/reset-device', redirectTo: 'dashboard/usuarios/reset-device', pathMatch: 'full' },
  { path: 'usuarios/new', redirectTo: 'dashboard/usuarios/new', pathMatch: 'full' },
  { path: 'usuarios', redirectTo: 'dashboard/usuarios/index', pathMatch: 'full' },

  { path: '**', redirectTo: 'auth' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
